import { AuthStatus } from 'constants/auth';
import { Viewer } from 'constants/user';
import { hasDashboardAccess } from 'services/client/token';
import type { FlowAccess } from 'components/MarketDataStatus';

/**
 * The viewer's options-flow entitlement, derived in ONE pure place so every surface classifies it
 * identically.
 *
 * Three states, not two. Entitlement resolves asynchronously, and the `Loading` window is real —
 * collapsing it into "not entitled" is how a paying subscriber ends up reading, with total
 * confidence, that their tape is delayed for as long as the claim takes to arrive. Callers must
 * render nothing about a plan while this is `unknown`.
 *
 * `delayed` is every viewer who is not entitled and not still loading — anonymous visitors and
 * signed-in users without dashboard access alike — because from the tape's side they are the same:
 * the 30-minute feed. Keeping this the single definition is what stops `useFlowAccess` (the status
 * dot) and `useTickerFlowData` (the fetch path) from ever drifting into disagreeing about who is
 * paid.
 */
export const classifyFlowAccess = (viewer: Viewer): FlowAccess => {
  if (viewer.status === AuthStatus.Loading) return 'unknown';
  if (viewer.status === AuthStatus.User && hasDashboardAccess(viewer)) return 'live';
  return 'delayed';
};

export default classifyFlowAccess;
